import { gql } from '@apollo/client';

import { professorActivityAnswerFragment } from '../fragments';
import { ProfessorActivityAnswer } from '../../types';

export interface DeleteActivityAnswerFeedbackMutationVariables {
  courseId: string;
  activityId: string;
  answerId: string;
}

export interface DeleteActivityAnswerFeedbackMutationResult {
  answer: ProfessorActivityAnswer;
}

export const deleteActivityAnswerFeedbackMutation = gql`
  mutation DeleteActivityAnswerFeedbackMutation($courseId: String!, $activityId: String!, $answerId: String!) {
    answer(courseId: $courseId, activityId: $activityId, answerId: $answerId)
      @rest(type: "ActivityAnswer", path: "courses/{args.courseId}/activities/{args.activityId}/answers/{args.answerId}/feedback", method: "DELETE") {
      ...ProfessorActivityAnswer
    }
  }
  ${professorActivityAnswerFragment}
`;
